'use client'

import { Toaster, ToastBar, toast } from 'react-hot-toast'

const SUCCESS_DURATION_MS = 30_000

export function AppToaster() {
    return (
        <Toaster
            position="top-center"
            reverseOrder={false}
            gutter={8}
            containerStyle={{
                top: 'env(safe-area-inset-top, 0px)',
            }}
            toastOptions={{
                duration: SUCCESS_DURATION_MS,
                style: {
                    background: '#363636',
                    color: '#fff',
                    borderRadius: '12px',
                    padding: '16px',
                    fontSize: '14px',
                    maxWidth: 'calc(100vw - 32px)',
                },
                success: {
                    duration: SUCCESS_DURATION_MS,
                    style: {
                        background: '#10b981',
                    },
                },
                error: {
                    duration: Infinity,
                    style: {
                        background: '#ef4444',
                    },
                },
            }}
        >
            {(t) => (
                <ToastBar toast={t} position={t.position || 'top-center'}>
                    {({ icon, message }) => (
                        <>
                            {icon}
                            {message}
                            {t.type === 'error' && (
                                <button
                                    type="button"
                                    onClick={() => toast.dismiss(t.id)}
                                    aria-label="Dismiss notification"
                                    className="ml-1 shrink-0 rounded-md p-1 text-white opacity-80 transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                    >
                                        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                                    </svg>
                                </button>
                            )}
                        </>
                    )}
                </ToastBar>
            )}
        </Toaster>
    )
}
